function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { canadianProvincesMap } from 'shared/core/constants/geography';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { MILLIGRAMS_PER_GRAM, GRAMS_PER_OUNCE, FLOWER_TYPES, CONCENTRATE_TYPES, EDIBLE_TYPES, TINCTURE_TYPES, TOPICAL_TYPES, WEIGHTED_TYPES, MILLILITERS_PER_OZ } from './constants';
export var getStateLimits = function(dispensaryState, customerState) {
    var outOfStateLimits = getComplianceConfig(dispensaryState, 'outOfStateLimits');
    var limits = getComplianceConfig(dispensaryState, 'limits');
    if (outOfStateLimits && dispensaryState && customerState && dispensaryState !== customerState) {
        limits = outOfStateLimits;
    }
    return limits;
};
export var getTypeLimits = function(cart) {
    var _limits_Flower, _limits_Concentrate, _limits_EdibleTHC, _limits_TinctureTHC, _limits_TopicalTHC, _limits_SolidEdibleNetWeight, _limits_LiquidEdibleVolumeInOunces, _limits_nonFlower;
    var limits = cart.limits, medical = cart.medical;
    var key = medical ? 'medical' : 'rec';
    var flowerLimit = ((_limits_Flower = limits.Flower) === null || _limits_Flower === void 0 ? void 0 : _limits_Flower[key]) || Infinity;
    var concentrateLimit = ((_limits_Concentrate = limits.Concentrate) === null || _limits_Concentrate === void 0 ? void 0 : _limits_Concentrate[key]) || Infinity;
    var edibleTHCLimit = ((_limits_EdibleTHC = limits.EdibleTHC) === null || _limits_EdibleTHC === void 0 ? void 0 : _limits_EdibleTHC[key]) || Infinity;
    var tinctureLimit = ((_limits_TinctureTHC = limits.TinctureTHC) === null || _limits_TinctureTHC === void 0 ? void 0 : _limits_TinctureTHC[key]) || Infinity;
    var topicalLimit = ((_limits_TopicalTHC = limits.TopicalTHC) === null || _limits_TopicalTHC === void 0 ? void 0 : _limits_TopicalTHC[key]) || Infinity;
    var solidEdibleNetWeightLimit = ((_limits_SolidEdibleNetWeight = limits.SolidEdibleNetWeight) === null || _limits_SolidEdibleNetWeight === void 0 ? void 0 : _limits_SolidEdibleNetWeight[key]) || Infinity;
    var liquidEdibleVolumeLimitInOunces = ((_limits_LiquidEdibleVolumeInOunces = limits.LiquidEdibleVolumeInOunces) === null || _limits_LiquidEdibleVolumeInOunces === void 0 ? void 0 : _limits_LiquidEdibleVolumeInOunces[key]) || Infinity;
    var nonFlowerLimit = ((_limits_nonFlower = limits.nonFlower) === null || _limits_nonFlower === void 0 ? void 0 : _limits_nonFlower[key]) || Infinity;
    var ignoreEdibleLimit = limits.ignoreEdibleLimit || false;
    return {
        flowerLimit: flowerLimit,
        concentrateLimit: concentrateLimit,
        edibleTHCLimit: edibleTHCLimit,
        tinctureLimit: tinctureLimit,
        topicalLimit: topicalLimit,
        solidEdibleNetWeightLimit: solidEdibleNetWeightLimit,
        liquidEdibleVolumeLimitInOunces: liquidEdibleVolumeLimitInOunces,
        nonFlowerLimit: nonFlowerLimit,
        ignoreEdibleLimit: ignoreEdibleLimit
    };
};
export var isFlower = function(type) {
    return _.includes(FLOWER_TYPES, type);
};
export var isConcentrate = function(type) {
    return _.includes(CONCENTRATE_TYPES, type);
};
export var isEdible = function(type) {
    return _.includes(EDIBLE_TYPES, type);
};
export var isTincture = function(type) {
    return _.includes(TINCTURE_TYPES, type);
};
export var isTopical = function(type) {
    return _.includes(TOPICAL_TYPES, type);
};
export var isWeightedProduct = function(param) {
    var type = param.type;
    return _.includes(WEIGHTED_TYPES, type);
};
export var getEffectiveSubcategories = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, useMultiSubcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var subcategory = product.subcategory, subcategories = product.subcategories;
    if (useMultiSubcategories && (subcategories === null || subcategories === void 0 ? void 0 : subcategories.length)) {
        return subcategories;
    }
    return _.compact([
        subcategory
    ]);
};
export var isLiquidTypeProduct = function(limits, type) {
    var subcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var _limits_liquidEdibleTypes, _limits_liquidEdibleTypes1;
    var _limits_liquidEdibleTypes_categories;
    var liquidCategories = (_limits_liquidEdibleTypes_categories = (_limits_liquidEdibleTypes = limits.liquidEdibleTypes) === null || _limits_liquidEdibleTypes === void 0 ? void 0 : _limits_liquidEdibleTypes.categories) !== null && _limits_liquidEdibleTypes_categories !== void 0 ? _limits_liquidEdibleTypes_categories : [];
    var _limits_liquidEdibleTypes_subcategories;
    var liquidSubcategories = (_limits_liquidEdibleTypes_subcategories = (_limits_liquidEdibleTypes1 = limits.liquidEdibleTypes) === null || _limits_liquidEdibleTypes1 === void 0 ? void 0 : _limits_liquidEdibleTypes1.subcategories) !== null && _limits_liquidEdibleTypes_subcategories !== void 0 ? _limits_liquidEdibleTypes_subcategories : [];
    var liquidTypes = _to_consumable_array(liquidCategories).concat(_to_consumable_array(liquidSubcategories));
    return _.includes(liquidTypes, type) || _.intersection(liquidTypes, subcategories).length > 0;
};
export var isSolidEdibleTypeProduct = function(type) {
    var subcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return isEdible(type) && !_.includes(subcategories, 'drinks');
};
export var getLimitForType = function(product, cart) {
    var useMultiSubcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var productType = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var limits = cart.limits;
    var _getTypeLimits = getTypeLimits(cart), flowerLimit = _getTypeLimits.flowerLimit, concentrateLimit = _getTypeLimits.concentrateLimit, edibleTHCLimit = _getTypeLimits.edibleTHCLimit, tinctureLimit = _getTypeLimits.tinctureLimit, topicalLimit = _getTypeLimits.topicalLimit, solidEdibleNetWeightLimit = _getTypeLimits.solidEdibleNetWeightLimit, liquidEdibleVolumeLimitInOunces = _getTypeLimits.liquidEdibleVolumeLimitInOunces;
    var currentType = narrowProductType(productType, subcategories, limits);
    var typeMap = {
        Flower: flowerLimit,
        Concentrate: concentrateLimit,
        Edible: limits.usesSolidEdibleTypes ? solidEdibleNetWeightLimit : edibleTHCLimit,
        Tincture: tinctureLimit,
        Topical: topicalLimit,
        Liquid: liquidEdibleVolumeLimitInOunces
    };
    return typeMap[currentType];
};
export var formatDisplayedType = function(type) {
    var typeMap = {
        Liquid: 'liquids',
        liquids: 'liquids',
        liquid: 'liquids',
        Tincture: 'tinctures',
        tintures: 'tinctures',
        tincture: 'tinctures',
        seeds: 'seeds',
        Edible: 'edibles',
        edibles: 'edibles',
        edible: 'edibles',
        Topical: 'topicals',
        topicals: 'topicals',
        topical: 'topicals',
        Flower: 'flower',
        flower: 'flower',
        'Pre-Rolls': 'flower',
        'pre-rolls': 'flower',
        cannabis: 'cannabis',
        Cannabis: 'cannabis',
        Concentrate: 'concentrates',
        concentrate: 'concentrates',
        Concentrates: 'concentrates',
        concentrates: 'concentrates',
        drinks: 'drinks'
    };
    return typeMap[type];
};
export var getLimitMessage = function(type, limit, state) {
    var unit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'g';
    var inCanada = _.has(canadianProvincesMap, state);
    var message = function(msgLimit, msgUnit) {
        return(// eslint-disable-next-line max-len
        "You've reached the ".concat(msgLimit).concat(msgUnit, " purchase limit for ").concat(type, " due to ").concat(inCanada ? 'federal' : 'state', " regulations."));
    };
    // if unit is milligrams, convert gram limit to milligrams
    if (unit === 'mg') {
        return message(limit *= MILLIGRAMS_PER_GRAM, unit);
    }
    // if Canada, convert oz limit to liters
    if (inCanada && type === 'liquids') {
        return message((limit / GRAMS_PER_OUNCE * MILLILITERS_PER_OZ / 1000).toFixed(1), 'L');
    }
    if (inCanada && type === 'liquid edibles') {
        return message((limit * MILLILITERS_PER_OZ / 1000).toFixed(1), 'L');
    }
    // if converting to oz results in a clean number gte to 1, show ozLimit
    var ozLimit = limit / GRAMS_PER_OUNCE;
    if (Math.round(ozLimit * 100) === ozLimit * 100 && ozLimit >= 1) {
        return message(ozLimit, 'oz');
    }
    return message(limit, unit);
};
export var narrowProductType = function(type) {
    var subcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], limits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (isFlower(type)) {
        return 'Flower';
    }
    if (isConcentrate(type)) {
        return 'Concentrate';
    }
    if (isLiquidTypeProduct(limits, type, subcategories)) {
        return 'Liquid';
    }
    if (isEdible(type) || isSolidEdibleTypeProduct(type, subcategories)) {
        return 'Edible';
    }
    if (isTincture(type)) {
        return 'Tincture';
    }
    if (isTopical(type)) {
        return 'Topical';
    }
    return type;
};
export var productIncludedInType = function(product, type, order) {
    var useMultiSubcategories = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var _dispensary_location, _ignoreTypeMap_type, _ignoreTypeMap_type1, _typeMap_type, _typeMap_type1;
    if (!type || !order) {
        return false;
    }
    var category = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var customerState = order.customerState, dispensary = order.dispensary;
    var limits = getStateLimits(dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.state, customerState);
    var typeMap = limits.typeMap, ignoreTypeMap = limits.ignoreTypeMap;
    var defaultsForType;
    switch(type){
        case 'Flower':
            defaultsForType = FLOWER_TYPES;
            break;
        case 'Concentrate':
            defaultsForType = CONCENTRATE_TYPES;
            break;
        case 'Edible':
            defaultsForType = EDIBLE_TYPES;
            break;
        case 'Tincture':
            defaultsForType = TINCTURE_TYPES;
            break;
        case 'Topicals':
            defaultsForType = TOPICAL_TYPES;
            break;
        default:
            defaultsForType = [
                type
            ];
    }
    var _ignoreTypeMap_type_categories;
    var ignoredCategoriesForType = (_ignoreTypeMap_type_categories = ignoreTypeMap === null || ignoreTypeMap === void 0 ? void 0 : (_ignoreTypeMap_type = ignoreTypeMap[type]) === null || _ignoreTypeMap_type === void 0 ? void 0 : _ignoreTypeMap_type.categories) !== null && _ignoreTypeMap_type_categories !== void 0 ? _ignoreTypeMap_type_categories : [];
    var _ignoreTypeMap_type_subcategories;
    var ignoredSubCategoriesForType = (_ignoreTypeMap_type_subcategories = ignoreTypeMap === null || ignoreTypeMap === void 0 ? void 0 : (_ignoreTypeMap_type1 = ignoreTypeMap[type]) === null || _ignoreTypeMap_type1 === void 0 ? void 0 : _ignoreTypeMap_type1.subcategories) !== null && _ignoreTypeMap_type_subcategories !== void 0 ? _ignoreTypeMap_type_subcategories : [];
    var _typeMap_type_categories;
    var includedCategoriesForType = (_typeMap_type_categories = typeMap === null || typeMap === void 0 ? void 0 : (_typeMap_type = typeMap[type]) === null || _typeMap_type === void 0 ? void 0 : _typeMap_type.categories) !== null && _typeMap_type_categories !== void 0 ? _typeMap_type_categories : [];
    var _typeMap_type_subcategories;
    var includedSubCategoriesForType = (_typeMap_type_subcategories = typeMap === null || typeMap === void 0 ? void 0 : (_typeMap_type1 = typeMap[type]) === null || _typeMap_type1 === void 0 ? void 0 : _typeMap_type1.subcategories) !== null && _typeMap_type_subcategories !== void 0 ? _typeMap_type_subcategories : [];
    // Only returns true if:
    // the product's category OR subcategory is NOT in the ignoreTypeMap overrides for the specified type, and...
    // the product's category OR subcategory is in the typeMap overrides or defaults for the specified type, or...
    // the product's category is the specified type
    var isIgnoredCategory = _.includes(ignoredCategoriesForType, category);
    var isIgnoredSubCategory = _.intersection(ignoredSubCategoriesForType, subcategories).length > 0;
    var isAddedCategory = _.includes(includedCategoriesForType, category);
    var isAddedSubCategory = _.intersection(includedSubCategoriesForType, subcategories).length > 0;
    if (isIgnoredCategory || isIgnoredSubCategory) {
        return false;
    }
    if (category !== type) {
        if (!isAddedCategory && !isAddedSubCategory && !_.includes(defaultsForType, category)) {
            return false;
        }
    }
    return true;
};
